module.exports = __webpack_public_path__ + "img/about_dice.951b741.png";